// extracted by mini-css-extract-plugin
module.exports = {"item":"SingleReport_item__14QY_","icon":"SingleReport_icon__Ct6P5"};